import Papa from "papaparse";

export function loadCSV(url) {
  return new Promise((resolve, reject) => {
    Papa.parse(url, {
      download: true,
      header: true,
      skipEmptyLines: true,
      dynamicTyping: true,
      complete: ({ data }) => resolve(data),
      error: reject,
    });
  });
}

export const DATA = {
  economia: {
    widDesigualdad:  "/data/economia/wid_desigualdad.csv",
    widGini:         "/data/economia/wid_gini.csv",
    widComparacion:  "/data/economia/wid_comparacion.csv",
    aecSectores:     "/data/economia/aec_exportaciones_sector.csv",
    aecSocios:       "/data/economia/aec_socios.csv",
  },
  trabajo: {
    anual:    "/data/trabajo/trabajo_anual.csv",
    dataset:  "/data/trabajo/trabajo_dataset.csv",
    tasas:    "/data/trabajo/trabajo_tasas.csv",
    piramide: "/data/trabajo/trabajo_piramide.csv",
    esi:      "/data/trabajo/trabajo_esi_ingresos.csv",
    ocupadosMensual:  "/data/trabajo/ocupados_mensual.csv",
    tasaDesocupacion: "/data/trabajo/tasa_desocupacion.csv",
    empleosGobierno:  "/data/trabajo/empleos_gobierno.csv",
    remuneracionesIPC:"/data/trabajo/remuneraciones_ipc.csv",
    immSerie:         "/data/trabajo/imm_serie.csv",
    jornadaEfectiva:  "/data/trabajo/jornada_efectiva.csv",
    cuidados:         "/data/trabajo/cuidados_fuerza_trabajo.csv",
    ele7Sindicatos:   "/data/trabajo/ele7_sindicalizacion.csv",
  },
  migracion: {
    permisosAnuales:     "/data/migracion/permisos_anuales.csv",
    rtSubcategorias:     "/data/migracion/rt_subcategorias.csv",
    permisosNacionalidad:"/data/migracion/permisos_nacionalidad.csv",
    permisosRegion:      "/data/migracion/permisos_region.csv",
    permisosSexo:        "/data/migracion/permisos_sexo.csv",
    refugio:             "/data/migracion/refugio.csv",
    poblacion:           "/data/migracion/poblacion_migrante.csv",
    poblacionNacionalidad:"/data/migracion/poblacion_migrante_nacionalidad.csv",
    poblacionRegion:     "/data/migracion/poblacion_migrante_region.csv",
    indicesDemograficos: "/data/migracion/indices_demograficos.csv",
    expulsionesMaterializadas: "/data/migracion/expulsiones_materializadas.csv",
    pasosNoHabilitados:  "/data/migracion/pasos_no_habilitados.csv",
    denunciasAdministrativas: "/data/migracion/denuncias_administrativas.csv",
    salidasVoluntarias:  "/data/migracion/salidas_voluntarias.csv",
  },
  seguridad: {
    homicidiosTasa:    "/data/seguridad/homicidios_tasa.csv",
    homicidiosDetalle: "/data/seguridad/homicidios_detalle.csv",
    casosFamilias:     "/data/seguridad/casos_policiales_familias.csv",
    dmcsGrupos:        "/data/seguridad/dmcs_grupos.csv",
    enusc:             "/data/seguridad/enusc.csv",
  },
  salud: {
    fonasaBenef:   "/data/salud/fonasa/beneficiarios_fonasa.csv",
    isapreBenef:   "/data/salud/isapre/beneficiarios_isapre.csv",
    fonasaTipo:    "/data/salud/fonasa/titulares_cargas_fonasa.csv",
    isapreTipo:    "/data/salud/isapre/cotizantes_cargas_isapre.csv",
    fonasaSexo:    "/data/salud/fonasa/titulares_cargas_sexo_fonasa.csv",
    isapreSexo:    "/data/salud/isapre/cotizantes_cargas_sexo_isapre.csv",
    pibTotal:      "/data/salud/indicadores/Participacion_sector_salud_total_en_el_PIB.csv",
    pibPublPriv:   "/data/salud/indicadores/Participacion_publico_y_privado_salud_en_el_PIB.csv",
    perCapitaCte:  "/data/salud/indicadores/Per_capita_en_Salud_Constante.csv",
    perCapitaCor:  "/data/salud/indicadores/Per_capita_en_Salud_Corriente.csv",
    perCapitaPPA:  "/data/salud/indicadores/Per_capita_en_Salud_PPA.csv",
  },
};
